module.exports = __webpack_public_path__ + "media/src/application/media/v2-main-img-87c324a3ad9457111b340b1b78eea9dd.svg";